module.exports = __webpack_public_path__ + "static/media/circledivided.0d86e31e.svg";